import { useMemo } from 'react';

import type { SectionTree } from '../components/SectionMenu';

import { useCurrentProductOrSection } from './useCurrentProductOrSection';

export const useCurrentSectionParams = (sectionTree: SectionTree) => {
    const { routeData } = useCurrentProductOrSection();

    const escapedName1 = routeData?.section1;
    const escapedName2 = routeData?.section2;
    const escapedName3 = routeData?.section3;
    const isValidSectionRoute = !routeData.product && !routeData.productId;

    const section1 = useMemo(
        () =>
            (escapedName1 && sectionTree.find((item) => item.escapedName === escapedName1)) ||
            undefined,
        [escapedName1, sectionTree],
    );

    const section2 = useMemo(
        () =>
            (escapedName2 &&
                section1?.children.find((item) => item.escapedName === escapedName2)) ||
            undefined,
        [section1, escapedName2],
    );

    const section3 = useMemo(
        () => section2?.children.find((item) => item.escapedName === escapedName3),
        [section2, escapedName3],
    );

    const currentSection = useMemo(() => {
        if (escapedName1 && !escapedName2) return section1;
        if (escapedName1 && escapedName2 && !escapedName3) return section2;
        return section3;
    }, [escapedName1, escapedName2, escapedName3, section1, section2, section3]);

    const currentSectionId = currentSection?.id;

    const sectionTrail = useMemo(
        () => [section1, section2, section3].filter(Boolean),
        [section1, section2, section3],
    );
    const currentSectionPath = `/${[escapedName1, escapedName2, escapedName3]
        .filter((section) => !!section)
        .join('/')}`;

    const currentSectionLevel = sectionTrail.length;

    return {
        currentSectionLevel,
        currentSectionPath,
        section1,
        section2,
        section3,
        currentSection,
        currentSectionId,
        sectionTrail,
        productId: routeData?.productId,
        /** If we get a product path but dont have a product id, the path is matched to long! */
        isValidSectionRoute,
    };
};
